import { Component } from '@angular/core';
import { ScrollService } from '../../splash-service';
import { Router } from '@angular/router';
import { NAV_OPTIONS } from '../../splash-page/splash.config';
import { KeycloakService } from 'keycloak-angular';
import { environment } from '../../../../../environments/environment';
import { LoginService } from 'usermgmt';

@Component({
  selector: 'app-splash-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  navOptions = NAV_OPTIONS;
    isLoggedIn : boolean = false;

  constructor(
    private scrollService: ScrollService,
    private keycloak: KeycloakService,
    private route: Router,
    private loginService: LoginService,
  ) {
    this.initMethod();
  }

  initMethod() {
    this.isLoggedIn = this.keycloak.isLoggedIn();
    if(this.isLoggedIn) {
      this.route.navigate(['landing-page']);
    }else{
      localStorage.clear();
    }
  }
  
  scrollTo(componentId: string) {
    this.scrollService.triggerScroll(componentId);
  }

  navigateTo(route: any[]) {
    this.reinitializeKeycloak();
  }

   async reinitializeKeycloak(): Promise<void> {
     try {
       if (this.isLoggedIn) {
         await this.keycloak.logout(environment.KEYCLOAK_URLS.LOGOUT_URL); // Log out if logged in
        }
        // Reinitialize Keycloak with new realm and clientId
        await this.keycloak.init({
        config: {
          realm: environment.REALM_NAME,
          clientId: environment.CLIENT_ID,
          url: environment.KEYCLOAK_URLS.BASE_URL,
        
        },
        initOptions: {
          onLoad: 'check-sso',
          checkLoginIframe: true,
          checkLoginIframeInterval: 100,
          silentCheckSsoRedirectUri: window.location.origin + '/assets/silent-check-sso.html',
          redirectUri:environment.KEYCLOAK_URLS.REDIRECT_URL
        }
      });

         await this.login();

    } catch (error) {
      console.error("Error during Keycloak reinitialization:", error);
    }
  }

  async login(): Promise<void> {
    this.loginService.initiateLogin();
  }
}
